import { Directive, ElementRef, Renderer2, HostListener, Input, NgZone, Optional, OnInit, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { Calendar } from 'primeng/calendar';
import { Dropdown } from 'primeng/dropdown';
import { TreeSelect } from 'primeng/treeselect';

@Directive({
    selector: 'input[filterButton], p-dropdown[filterButton], p-calendar[filterButton], p-treeSelect[filterButton]'
})
export class FilterButtonSuffix implements OnInit {
    private filterButton: HTMLButtonElement | null = null;
    @Input() left: string = '3%';
    constructor(
        private el: ElementRef<any>, 
        @Optional() private dropdown: Dropdown, 
        @Optional() private calendar: Calendar, 
        @Optional() private tree: TreeSelect, 
        private renderer: Renderer2, 
        private cd: ChangeDetectorRef,
        private ngZone: NgZone) { }


    value: any;

    ngOnInit() {
        this.addfilterButton();
        this.setupValueChangeListeners();
        this.updateButtonVisibility();
    }



    private addfilterButton() {
        const parent = this.renderer.parentNode(this.el.nativeElement);
        if (!parent) return;

        // Create a container div
        const wrapper = this.renderer.createElement('div');
        this.renderer.setStyle(wrapper, 'display', 'flex');
        this.renderer.setStyle(wrapper, 'align-items', 'center');
        this.renderer.setStyle(wrapper, 'width', '100%');

        // Clone the input and move it inside the wrapper
        this.renderer.insertBefore(parent, wrapper, this.el.nativeElement);
        this.renderer.appendChild(wrapper, this.el.nativeElement);

        // Create the suffix button
        this.filterButton = this.renderer.createElement('button');
        this.renderer.setProperty(this.filterButton, 'innerHTML', `<i class="pi pi-times"></i>`);
        this.renderer.setStyle(this.filterButton, 'background', 'transparent');
        this.renderer.setStyle(this.filterButton, 'border', 'none');
        this.renderer.setStyle(this.filterButton, 'cursor', 'pointer');
        this.renderer.setStyle(this.filterButton, 'padding', '5px');
        this.renderer.setStyle(this.filterButton, 'color', '#aaaaaa');
        this.renderer.setStyle(this.filterButton, 'position', 'relative');
        if (this.el.nativeElement instanceof HTMLInputElement) {
            this.renderer.setStyle(this.filterButton, 'left', this.left);
        } else {
            let rect;
            if (this.dropdown) {
                rect = this.dropdown.el.nativeElement.getBoundingClientRect();
                this.renderer.setStyle(this.dropdown.el.nativeElement, 'width', '100%')
            } else if (this.calendar) {
                rect = this.calendar.el.nativeElement.getBoundingClientRect()
                this.renderer.setStyle(this.calendar.el.nativeElement, 'width', '100%')
                this.renderer.setStyle(this.filterButton, 'left', '2.5rem');

            } else if (this.tree) {
                rect = this.tree.el.nativeElement.getBoundingClientRect()
                this.renderer.setStyle(this.tree.el.nativeElement, 'width', '100%')
            }

            if (!this.calendar) {
                this.renderer.setStyle(this.filterButton, 'left', '3.9rem');
            }
            this.renderer.setStyle(this.filterButton, 'top', `0px`);
        }

        this.renderer.setAttribute(this.filterButton, 'pButton', '');
        this.renderer.setAttribute(this.filterButton, 'text', 'true');
        this.renderer.setAttribute(this.filterButton, 'rounded', 'true');
        this.renderer.setAttribute(this.filterButton, 'severity', 'danger');

        // Append the button
        this.renderer.appendChild(wrapper, this.filterButton);

        // Add click event
        this.renderer.listen(this.filterButton, 'click', () => {
            this.el.nativeElement.value = '';
            if (this.el.nativeElement instanceof HTMLInputElement) {
                this.el.nativeElement.dispatchEvent(new Event('input', { bubbles: true }));
            } else {
                //handle other cases
                if (this.dropdown) {
                    this.dropdown.value = null;
                    this.dropdown.cd.detectChanges()
                    this.dropdown.onModelChange(null)
                    this.dropdown.clear(new Event('input', { bubbles: true }))
                    this.refreshPrimeNGComponent(this.dropdown);
                } else if (this.calendar) {
                    this.calendar.value = null;
                    this.calendar.cd.detectChanges()
                    this.calendar.onModelChange(null)
                    this.calendar.clear();
                    this.refreshPrimeNGComponent(this.calendar);
                } else if (this.tree) {
                    this.tree.value = null;
                    this.tree.cd.detectChanges();
                    this.tree.onModelChange(null);
                    this.tree.clear(new Event('input', { bubbles: true }));
                    this.refreshPrimeNGComponent(this.tree);
                }
            }

            this.updateButtonVisibility();
        });

        // Listen for changes to update visibility
        this.observeValueChanges();
        //this.renderer.listen(this.el.nativeElement, 'select', () => this.updateButtonVisibility());
    }

    private updateButtonVisibility() {
        let hasValue = !!this.el.nativeElement.value;

        if (this.el.nativeElement instanceof HTMLInputElement) {
            hasValue = !!this.el.nativeElement.value;
        } else if (this.dropdown) {
            hasValue = !!this.dropdown.value;
        } else if (this.calendar) {
            hasValue = !!this.calendar.value;
        } else if (this.tree) {
            hasValue = !!this.tree.value;
        }

        console.log("setting visibility to: ", hasValue)

        // this.renderer.setStyle(this.filterButton!, 'display', hasValue ? 'inline-block' : 'none');


        this.renderer.setStyle(this.filterButton, 'display', hasValue ? 'inline-block' : 'none')
    }

    private setupValueChangeListeners() {
        if (this.el.nativeElement instanceof HTMLInputElement) {
            this.renderer.listen(this.el.nativeElement, 'input', () => this.updateButtonVisibility());
        }

        // if (this.dropdown) {
        //     this.dropdown.onModelChange = (value: any) => {
        //         this.dropdown.value = value;
        //         this.updateButtonVisibility();
        //         return value;
        //     };
        //     this.dropdown.onModelChange(this.dropdown.value);
        // } else if (this.calendar) {
        //     this.calendar.onModelChange = (value: any) => {
        //         this.calendar.value = value;
        //         this.updateButtonVisibility();
        //         return value;
        //     };
        //     this.calendar.onModelChange(this.calendar.value);
        // } else if (this.tree) {
        //     this.tree.onModelChange = (value: any) => {
        //         this.tree.value = value;
        //         this.updateButtonVisibility();
        //         return value;
        //     };
        //     this.tree.onModelChange(this.tree.value);
        // }


    }

    private observeValueChanges() {
        const observer = new MutationObserver(() => this.updateButtonVisibility());

        observer.observe(this.el.nativeElement, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
        });
    }

    private refreshPrimeNGComponent(component: any) {
        if (component && component.writeValue) {
            component.writeValue(null);
        }

        if (component.updateUI) {
            component.updateUI();
        }

        if (component.cd) {
            component.cd.detectChanges();
        }
    }


    ngAfterViewInit() {
    }
}
